
import { ChangeEvent, ClickEvent, SaveButton } from "@mcleod/components";
import { Api, Model, ModelRow } from "@mcleod/core";
import { AutogenLayoutGlaMapBrokerageCode } from "./autogen/AutogenLayoutGlaMapBrokerageCode";

export class GlaMapBrokerageCode extends AutogenLayoutGlaMapBrokerageCode {

    private _saveButton: SaveButton;
    private _smc3LastExternalText: string = "";
    private _p44LastExternalText: string = "";
    private _p44Record: ModelRow;
    private _smc3Record: ModelRow;

    public set saveButton(value: SaveButton) {
        this._saveButton = value;
    }

    public get saveButton() {
        return this._saveButton;
    }

    public get p44Record(): ModelRow {
        return this._p44Record;
    }

    public set p44Record(value: ModelRow) {
        this._p44Record = value;
    }

    public get smc3Record(): ModelRow {
        return this._smc3Record;
    }

    public set smc3Record(value: ModelRow) {
        this._smc3Record = value;
    }

    override async onLoad() {
        this.p44Record = await Model.searchSingleRecord("lme/powerbroker/contract-management-control", { id: "P44" });
        this.smc3Record = await Model.searchSingleRecord("lme/powerbroker/contract-management-control", { id: "SLA" });
        this.panelP44.visible = this.p44Record?.getBoolean("is_active");
        this.panelSMC3.visible = this.smc3Record?.getBoolean("is_active");
    }

    async buttonReviewOnClick(event: ClickEvent) {
        let mapBrokerageCodeList: [];
        const glaCode = (null == this.textboxGlaCode.lookupModelData) ? "" : this.textboxGlaCode.lookupModelData[0]?.data["gla_code"];
        const otherChargeId = (null == this.textboxOtherChargeCode.lookupModelData) ? "" : this.textboxOtherChargeCode.lookupModelData[0]?.data["id"];
        const deductCodeId = (null == this.textboxDeductCode.lookupModelData) ? "" : this.textboxDeductCode.lookupModelData[0]?.data["id"];
        await Api.post("lme/dispatch/generate-gla-brokerage-codes", {
            gla_code: glaCode, description: this.textboxDescription.text,
            other_charge_code: otherChargeId, deduct_code: deductCodeId, from_p44: this.textboxFromP44.text,
            to_p44: this.textboxToP44.text, from_smc3: this.textboxFromSmc3.text, to_smc3: this.textboxToSmc3.text,
            smc3_g2e_is_blank: this.checkboxSaveAsSMC3Blank.checked, p44_g2e_is_blank: this.checkboxSaveAsP44Blank.checked
        }).then(async response => {
            mapBrokerageCodeList = response.data[0]?.map_brokerage_code_list;
            this.saveButton.enabled = (mapBrokerageCodeList.length > 0);
            const modelRows: ModelRow[] = mapBrokerageCodeList.map(row => new ModelRow(this.sourceMapBrokerageCode.url, true, row));
            this.tableMapBrokerageCode.dataSource.data = modelRows;
            this.tableMapBrokerageCode.displayData(null, modelRows, 0);
        });
    }

    checkboxSaveAsP44BlankOnChange(event: ChangeEvent) {
        if (this.checkboxSaveAsP44Blank.checked) {
            this._p44LastExternalText = this.textboxToP44.text;
            this.textboxToP44.text = "";
            this.textboxToP44.enabled = false;
        } else {
            this.textboxToP44.text = this._p44LastExternalText;
            this.textboxToP44.enabled = true;
        }
    }

    checkboxSaveAsSMC3BlankOnChange(event: ClickEvent) {
        if (this.checkboxSaveAsSMC3Blank.checked) {
            this._smc3LastExternalText = this.textboxToSmc3.text;
            this.textboxToSmc3.text = "";
            this.textboxToSmc3.enabled = false;
        } else {
            this.textboxToSmc3.text = this._smc3LastExternalText;
            this.textboxToSmc3.enabled = true;
        }
    }
}
